import './History.css';
import { formatDuration, formatDate } from '../utils/formatters';

const History = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="history">
        <h3 className="history__title">Recent Activity</h3>
        <div className="history__list">
          {[1, 2, 3].map(i => (
            <div key={i} className="history-item history-item--loading">
              <div className="skeleton skeleton--date" />
              <div className="skeleton skeleton--movie" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const sessions = data?.sessions || [];

  if (sessions.length === 0) {
    return (
      <div className="history">
        <h3 className="history__title">Recent Activity</h3>
        <p className="history__empty">No watch history yet</p>
      </div>
    );
  }

  // Group sessions by date
  const groupedByDate = sessions.reduce((acc, session) => {
    const date = formatDate(session.date);
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(session);
    return acc;
  }, {});

  return (
    <div className="history">
      <h3 className="history__title">Recent Activity</h3>
      <div className="history__list">
        {Object.entries(groupedByDate).map(([date, sessions]) => (
          <div key={date} className="history__group">
            <span className="history__date">{date}</span>
            {sessions.map((session, idx) => (
              <div key={idx} className="history-item">
                <span className="history-item__movie">{session.movie || session.title}</span>
                <span className="history-item__meta">
                  {formatDuration(session.duration)}
                  {session.user && <> · {session.user}</>}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default History;
